/**
 * Disk Health Hooks
 * =================
 * React Query hooks for the Disk Health page.
 */

import { useQuery } from '@tanstack/react-query'
import { assetApi } from '@/services/api'
import type { DiskHealthSearchParams } from '@/types'

export const diskHealthKeys = {
  all: ['disk-health'] as const,
  list: (params?: DiskHealthSearchParams) => [...diskHealthKeys.all, 'list', params] as const,
  stats: () => [...diskHealthKeys.all, 'stats'] as const,
}

/**
 * Hook to fetch paginated disk health drive list.
 */
export function useDiskHealth(params?: DiskHealthSearchParams) {
  return useQuery({
    queryKey: diskHealthKeys.list(params),
    queryFn: () => assetApi.getDiskHealth(params),
  })
}

/**
 * Hook to fetch disk health summary statistics.
 */
export function useDiskHealthStats() {
  return useQuery({
    queryKey: diskHealthKeys.stats(),
    queryFn: () => assetApi.getDiskHealthStats(),
  })
}
